import { useLocation } from "react-router-dom";
import { useDarkMode } from "@/context/DarkModeContext";

export default function NotFound() {
  const location = useLocation();
  const { isDark } = useDarkMode();

  return (
    <div className={`relative flex flex-col items-center justify-center h-screen text-center px-4 transition-colors duration-300 ${isDark ? "bg-gray-950" : "bg-white"}`}>
      <h1 className={`absolute bottom-0 text-9xl md:text-[12rem] font-black select-none pointer-events-none z-0 ${isDark ? "text-gray-800" : "text-gray-50"}`}>
        404
      </h1>
      <div className="relative z-10">
        <h1 className={`text-xl md:text-2xl font-semibold mt-6 ${isDark ? "text-white" : "text-gray-900"}`}>This page has not been generated</h1>
        <p className={`mt-2 text-base font-mono ${isDark ? "text-gray-500" : "text-gray-400"}`}>{location.pathname}</p>
        <p className={`mt-4 text-lg md:text-xl ${isDark ? "text-gray-400" : "text-gray-500"}`}>Tell me more about this page, so I can generate it</p>
      </div>
    </div>
  );
}